/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Library_Example_ChapterInputs */

const en_mcp_cap_library_example_chapter = /** @type {(inputs: Mcp_Cap_Library_Example_ChapterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chapter 3 reading`)
};

const es_mcp_cap_library_example_chapter = /** @type {(inputs: Mcp_Cap_Library_Example_ChapterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lectura del capítulo 3`)
};

/**
* | output |
* | --- |
* | "Chapter 3 reading" |
*
* @param {Mcp_Cap_Library_Example_ChapterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_library_example_chapter = /** @type {((inputs?: Mcp_Cap_Library_Example_ChapterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Library_Example_ChapterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_library_example_chapter(inputs)
	return en_mcp_cap_library_example_chapter(inputs)
});